export default __webpack_public_path__ + "static/media/frutiger-65bold.6dd4d123.eot";